export default "__VITE_ASSET__FSE1MB8CncEwJnPMLSvuow__"